<template>
  <section>
    <div class="py-5 dark-section">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6 mb-4 mb-md-0 text-slide-in" :class="{ 'text-slide-in-active': textVisible }">
            <h2>Datenmanagement</h2>
            <p class="mb-4">
              Effizientes Datenmanagement ist der Schlüssel zu einem zukunftssicheren Unternehmenserfolg. Es bringt
              Struktur in Ihre Daten, gewährleistet höchste Qualität und macht Informationen jederzeit zugänglich.
              Nutzen Sie Ihre Daten als wertvolle Ressource, um smarte Entscheidungen zu treffen, Prozesse zu optimieren
              und Ihre Kosten nachhaltig zu senken. Setzen Sie auf klare Datenstrukturen und erschließen Sie das volle
              Potenzial Ihres Unternehmens!
            </p>
            <!--            <router-link to="/contact" class="btn btn-primary btn-lg mt-2">-->
            <!--              Kontaktieren Sie uns-->
            <!--              <i class="fas fa-envelope"></i>-->
            <!--            </router-link>-->
          </div>
          <div class="col-md-6 text-center">
            <img
                src="@/assets/datamanagement/data.jpg"
                alt="Motivation für Datenmanagement"
                class="img-fluid rounded-img shadow-sm top-image"
                :class="{ 'slide-in-active': imageVisible }"
            />
          </div>
        </div>

      </div>
    </div>

    <div class="py-5 light-section">
      <div class="container">
        <div class="row text-center mb-5">
          <div class="col-md-4">
            <i class="fas fa-folder-open fa-3x mb-3" style="color: #e2a84b;"></i>
            <h4>Datenkataloge erstellen</h4>
            <p>
              Lassen Sie umfassende Datenkataloge erstellen, um Ihre Informationen schnell und strukturiert auffindbar
              zu machen.
            </p>
          </div>
          <div class="col-md-4">
            <i class="fas fa-check-circle fa-3x mb-3" style="color: #e2a84b;"></i>
            <h4>Datenqualität sichern</h4>
            <p>
              Wir optimieren und sichern Ihre Datenqualität für eine zuverlässige Basis in der Analyse und
              Entscheidungsfindung.
            </p>
          </div>
          <div class="col-md-4">
            <i class="fas fa-search fa-3x mb-3" style="color: #e2a84b;"></i>
            <h4>Datenverfügbarkeit steigern</h4>
            <p>
              Erhöhen Sie die Verfügbarkeit Ihrer Daten im gesamten Unternehmen, um eine schnelle Time-to-Analytics zu
              gewährleisten.
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="py-5 dark-section">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6 text-center">
            <img
                src="@/assets/datamanagement/data2.jpg"
                alt="Unsere Datenmanagement-Lösung"
                class="img-fluid rounded-img shadow-sm solution-image"
                :class="{ 'slide-in-active': solutionImageVisible }"
            />
          </div>
          <div class="col-md-6 mb-4 mb-md-0 text-slide-up" :class="{ 'text-slide-up-active': solutionTextVisible }">
            <h2>Unsere Lösung</h2>
            <p class="mb-4">
              Unsere maßgeschneiderte Datenmanagement-Lösung stellt sicher, dass Ihre Daten sicher, nutzbar und leicht
              zugänglich sind – für ein dynamisches und datengetriebenes Unternehmen.
            </p>
            <router-link to="/contact" class="btn btn-primary btn-lg mt-2">
              Jetzt Kontakt aufnehmen
              <i class="fas fa-envelope"></i>
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="py-5 light-section">
      <div class="container">
        <div class="row text-center">
          <div class="col-md-12">
            <h2>Ihre Vorteile</h2>
            <p class="mb-4">
              Mit unserem auf Ihr Unternehmen zugeschnittenen Datenmanagement erzielen Sie eine höhere
              Datenverfügbarkeit, verkürzen Ihre Time-to-Analytics und ermöglichen fundierte Entscheidungen.
            </p>
          </div>
        </div>
        <div class="row text-center mt-4">
          <div class="col-md-4">
            <i class="fas fa-layer-group fa-3x mb-3" style="color: #e2a84b;"></i>
            <h4>Datenintegration</h4>
            <p>Nahtlose Integration aus verschiedenen Quellen schafft ein umfassendes Datenbild und verbessert die
              Entscheidungsqualität.</p>
          </div>
          <div class="col-md-4">
            <i class="fas fa-chart-line fa-3x mb-3" style="color: #e2a84b;"></i>
            <h4>Optimierte Entscheidungsfindung</h4>
            <p>Zuverlässige und gut zugängliche Daten schaffen die Basis für schnellere, fundierte Entscheidungen und
              minimieren Risiken in Ihrem Unternehmen.</p>
          </div>

          <div class="col-md-4">
            <i class="fas fa-clock fa-3x mb-3" style="color: #e2a84b;"></i>
            <h4>Verkürzte Time-to-Analytics</h4>
            <p>Eine schnelle Datenfindung und Analyse bieten schneller Zugang zu Erkenntnissen und ermöglichen Ihrem
              Unternehmen eine rasche Reaktion.</p>
          </div>
        </div>
      </div>
    </div>

  </section>
</template>

<script lang="ts">
import {defineComponent, ref, onMounted} from 'vue';

export default defineComponent({
  name: 'DataManagementPage',
  setup() {
    const textVisible = ref(false);
    const imageVisible = ref(false);
    const solutionTextVisible = ref(false);
    const solutionImageVisible = ref(false);

    onMounted(() => {
      const observerOptions = {
        root: null,
        threshold: 0.1,
      };

      const observerCallback = (entries: IntersectionObserverEntry[]) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            if (entry.target.classList.contains('top-image')) {
              imageVisible.value = true;
            } else if (entry.target.classList.contains('solution-image')) {
              solutionImageVisible.value = true;
            } else if (entry.target.classList.contains('text-slide-in')) {
              textVisible.value = true;
            } else if (entry.target.classList.contains('text-slide-up')) {
              solutionTextVisible.value = true;
            }
          }
        });
      };

      const observer = new IntersectionObserver(observerCallback, observerOptions);

      document.querySelectorAll('.text-slide-in, .top-image, .solution-image, .text-slide-up')
          .forEach(element => {
            observer.observe(element);
          });
    });

    return {textVisible, imageVisible, solutionTextVisible, solutionImageVisible};
  },
});
</script>

<style scoped lang="less">
@import '@/assets/style.less';
@import "@/assets/animations.less";

.top-image {
  margin-top: 2rem;
}
</style>
